<template>
  <transition-group
    name="expand"
    :tag="tag"
    @after-enter="afterEnter"
    @enter="enter"
    @leave="leave"
  >
    <slot />
  </transition-group>
</template>

<script>
export default {
  name: 'TransitionExpand',
  props: {
    tag: {
      type: String,
      default: 'span'
    }
  },
  methods: {
    afterEnter (element) {
      // eslint-disable-next-line no-param-reassign
      element.style.height = 'auto'
    },
    enter (element) {
      const { width } = getComputedStyle(element)
      /* eslint-disable no-param-reassign */
      element.style.width = width
      element.style.position = 'absolute'
      element.style.visibility = 'hidden'
      element.style.height = 'auto'
      /* eslint-enable */
      const { height } = getComputedStyle(element)
      /* eslint-disable no-param-reassign */
      element.style.width = null
      element.style.position = null
      element.style.visibility = null
      element.style.height = 0
      /* eslint-enable */
      // Força o repaint para garantir que a
      // animação seja acionada corretamente.
      // eslint-disable-next-line no-unused-expressions
      getComputedStyle(element).height
      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        element.style.height = height
      })
    },
    leave (element) {
      const { height } = getComputedStyle(element)
      // eslint-disable-next-line no-param-reassign
      element.style.height = height
      // Força o repaint para garantir que a
      // animação seja acionada corretamente.
      // eslint-disable-next-line no-unused-expressions
      getComputedStyle(element).height
      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        element.style.height = 0
      })
    }
  }
}
</script>

<style scoped>
* {
  will-change: height;
  transform: translateZ(0);
  perspective: 1000px;
}
</style>

<style>
  .expand-enter-active,
  .expand-leave-active {
    transition-property: opacity, height;
    transition: height 0.2s ease-in;
    overflow: hidden;
  }
  .expand-enter-from,
  .expand-leave-to {
    /*height: 0;*/
    opacity: 0;
  }
</style>
